export const DURATION_MS = 3000;
export const ONE_DAY = 24;

// Force refresh token every 55 minutes (Firebase tokens expire every 60 minutes)
export const FORCE_REFRESH_TOKEN_INTERVAL = 55 * 60 * 1000;

export const STOP_GENERATION_DEBOUNCE = 2000; // 2 seconds
